module.exports = __webpack_public_path__ + "static/media/daily.ae05f713.png";